import React from 'react';

import RupeeIcon from '../../../icons/Rupee';

import PriceLock from '../PriceLockListing/price-lock-listing';

import * as S from '../SrpCard/srp-card-ui.styles';

export default function FareOptions({
  priceLockDetails,
  ancillaryList,
  onBookClickHandler = index => {},
  onLockClickHandler = index => {},
  messageValues,
  getPriceLockInfoHtml,
  isLoggedIn,
  logPDT = () => {},
  showFareFamilyPersuasionText = false
}) {
  return ancillaryList.map((ancillary, index) => {
    return (
      <div className="flexCol" key={'FareOption_' + index}>
        <div className="flexCol padT20 padB20 borderTop">
          <div className="padR20 padL20 dF justifyBetween">
            <S.ViewFaresLeft className="flexCol padB10">
              <div className="dF alignItemsCenter padB15 padT5">
                {ancillary.headerIcon ? (
                  <img
                    src={`https://gos3.ibcdn.com/${ancillary.headerIcon}`}
                    width="65"
                    height="20"
                    className="padL5"
                    alt="ancillary_header"
                    loading="lazy"
                  />
                ) : null}
                <span className="font16 fb quicks black padR5">{ancillary.header}</span>
                {ancillary.tag ? (
                  <img
                    width="60"
                    height="30"
                    src={`https://gos3.ibcdn.com/${ancillary.tag}`}
                    alt="ancillary_tag"
                    loading="lazy"
                  />
                ) : null}
                {(showFareFamilyPersuasionText && ancillary.persuasionText && (
                  <span
                    className="upgardeFFtag"
                    dangerouslySetInnerHTML={{ __html: ancillary.persuasionText }}
                  ></span>
                )) ||
                  null}
              </div>
              {ancillary?.detailsList?.map(item => (
                <div className="dF font12 padB5 alignItemsCenter" key={item.t}>
                  <S.Col5 className="dF padL0 alignItemsCenter">
                    <img
                      src={`https://gos3.ibcdn.com/${item.i}`}
                      width="12"
                      height="12"
                      alt="ancillary_details_list"
                      loading="lazy"
                    />
                    <span className="padL5 grey">{item?.t?.split('\n').join(', ')}</span>
                  </S.Col5>
                  <S.Col5
                    dangerouslySetInnerHTML={{ __html: item?.v?.split('\n').join(', ') }}
                  ></S.Col5>
                </div>
              ))}
            </S.ViewFaresLeft>
            <div className="dF">
              <span className="flexCol alignItemsEnd padB5">
                <span className="alignItemsCenter dF padT2 quicksand">
                  <RupeeIcon width="1rem" height="1rem" fill="#333333" loading="lazy" />
                  <span className="font20 fb">{ancillary.bundleAmt}</span>
                </span>
              </span>
              <S.ButtonOuter className="flexCol">
                {(ancillary.hasPriceLock && getPriceLockInfoHtml && (
                  <PriceLock
                    details={priceLockDetails}
                    fare={ancillary.bundleAmt}
                    messageValues={messageValues}
                    bookPriceLock={onLockClickHandler}
                    getPriceLockInfoHtml={getPriceLockInfoHtml}
                    isLoggedIn={isLoggedIn}
                    logPDT={logPDT}
                  />
                )) ||
                  null}
                <span className="dF flexCol">
                  <span className="db clearfix">
                    <S.Fltbook
                      className="fb quicksand widthF105"
                      value="BOOK"
                      onClick={() => onBookClickHandler(index)}
                    />
                  </span>
                </span>
              </S.ButtonOuter>
            </div>
          </div>
        </div>
      </div>
    );
  });
}
